import React, { useState } from 'react';

import ModalTemplate from "../../../component/modal/ModalTemplate";
import Loading from "../../../component/loading/Loading";
import { SECONDARY_BTN, DANGER_BTN, INPUT, LABEL, FOOTER_END, DANGER_CALLOUT } from "./modalStyle";

const CONFIRM_TEXT = '탈퇴합니다';

interface WithdrawModalProps {
    isOpen: boolean;
    loading?: boolean;
    onRequestClose: () => void;
    onSubmit: (data: { agreeIrreversible: boolean; confirmText: string }) => void;
}

/** 회원 탈퇴 전 비가역 파기 내용을 확인하는 모달 */
const WithdrawModal: React.FC<WithdrawModalProps> = ({ isOpen, loading = false, onRequestClose, onSubmit }) => {
    const [agreeIrreversible, setAgreeIrreversible] = useState(false);
    const [confirmText, setConfirmText] = useState('');

    const handleClose = () => {
        setAgreeIrreversible(false);
        setConfirmText('');
        onRequestClose();
    };

    const handleSubmit = () => {
        if (!agreeIrreversible) {
            alert('개인정보 비가역 파기 안내를 확인하고 동의해주세요.');
            return;
        }
        if (confirmText !== CONFIRM_TEXT) {
            alert(`확인 문구에 '${CONFIRM_TEXT}'를 입력해주세요.`);
            return;
        }
        if (!window.confirm('회원 탈퇴를 진행하시겠습니까? 탈퇴 후에는 계정을 복구할 수 없습니다.')) return;
        onSubmit({ agreeIrreversible: true, confirmText: CONFIRM_TEXT });
    };

    return (
        <ModalTemplate
            open={isOpen}
            handleClose={handleClose}
            modalTitle="회원 탈퇴"
            className="react-modal"
        >
            <Loading loading={loading} />
            <div className="modal-body">
                <div className={DANGER_CALLOUT}>
                    <strong className="tw-block tw-text-sm tw-font-semibold">탈퇴 전 꼭 확인해주세요.</strong>
                    <p className="tw-mt-2 tw-mb-0 tw-text-sm tw-leading-relaxed">
                        탈퇴하면 이름, 연락처, 이메일 등 개인정보가 복구할 수 없는 방법으로 파기됩니다.
                        <br />탈퇴 후에는 계정을 복구하거나 재활성화할 수 없습니다.
                    </p>
                </div>
                <div className="tw-mb-4 tw-flex tw-items-center tw-gap-2">
                    <input
                        id="agreeIrreversible"
                        className="tw-h-4 tw-w-4 tw-rounded tw-border-[#dee2e6] tw-accent-[#5D87FF]"
                        type="checkbox"
                        checked={agreeIrreversible}
                        onChange={(event) => setAgreeIrreversible(event.target.checked)}
                    />
                    <label className="tw-text-sm tw-text-[#495057]" htmlFor="agreeIrreversible">
                        개인정보 파기 및 계정 복구 불가 내용을 확인했습니다.
                    </label>
                </div>
                <label className={LABEL} htmlFor="withdrawConfirmText">
                    탈퇴를 진행하려면 <strong>{CONFIRM_TEXT}</strong>를 입력해주세요.
                </label>
                <input
                    id="withdrawConfirmText"
                    className={INPUT}
                    value={confirmText}
                    onChange={(event) => setConfirmText(event.target.value)}
                    placeholder={CONFIRM_TEXT}
                    autoComplete="off"
                />
            </div>
            <div className={FOOTER_END}>
                <button type="button" className={DANGER_BTN} onClick={handleSubmit}>탈퇴</button>
                <button type="button" className={SECONDARY_BTN} onClick={handleClose}>취소</button>
            </div>
        </ModalTemplate>
    );
};

export default WithdrawModal;
